import React from 'react';
import { Row, Col } from 'reactstrap';
import dayjs from 'dayjs';
import LocalizedFormat from 'dayjs/plugin/localizedFormat';
import StackedBarChart2 from '../Charts/StackedBarChart2.jsx';

dayjs.extend(LocalizedFormat)

class TimelinePanel2 extends React.Component {
  constructor(props) {
    super();
    this.state = {
    };
    this.summaryData = [];
  }

  componentWillReceiveProps(nextProps) {
    this.updateVisualData(nextProps)
  }

  shouldComponentUpdate(nextProps, nextState) {
    if(nextProps.filterTimeStamp !== this.props.filterTimeStamp)
      return true;
    return false
  }

  selectSeason = (season => {
    let sel = this.timeSegments[season].start.add(1, 'month');
    this.props.selectYearMonth(sel.year(), sel.month());
  }).bind(this)

  updateVisualData(props) {
    let {
      listEMMethod,
      dataListEMDs,
    } = props.base;
    let {
      filterResults,
    } = props.filtered;

    // three months for a time segment
    let dateMin = dayjs(Math.min(...filterResults.map(i => dataListEMDs[i].t)))
    let lastTimeTick = dayjs().subtract((dayjs().month() % 3), 'month').date(1);
    this.timeSegments = [{start: lastTimeTick, end: dayjs(), id: 1, maps: [],
      name: `${lastTimeTick.format('ll')} - ${dayjs().format('ll')}`}];
    for(let i=2; lastTimeTick>dateMin; ++i) {
      let start = lastTimeTick.subtract(3, 'month');
      let end = lastTimeTick;
      this.timeSegments.unshift({start, end, id: +i, maps: [],
        name: `${start.format('ll')} - ${end.format('ll')}`});
      lastTimeTick = start;
    }

    // segment filtered result by date
    filterResults.forEach(i => {
      let segIdx = Math.floor(dayjs(dataListEMDs[i].t).diff(lastTimeTick, 'month') / 3);
      if(segIdx < 0)
        return;
      this.timeSegments[segIdx].maps.push(i);
    })

    this.summaryData = this.timeSegments.map(seg => {
      let counterMethod = listEMMethod.map(m => 0);
      seg.maps.forEach(i => {
        counterMethod[dataListEMDs[i].m]++;
      });
      return {
        name: seg.name,
        id: +seg.id,
        values: counterMethod,
      };
    })
  }

  render() {
    let {sizeFactor} = this.props;
    if(!sizeFactor) sizeFactor = 1;
    return (
      <div>
        <Row>
          <Col xs={12}>
            <StackedBarChart2
              width={400 * sizeFactor}
              height={145 * sizeFactor}
              listRange={[0, this.summaryData.length]}
              schema={this.props.filtered.compareDataInfo}
              data={this.summaryData}
              onSelected={this.selectSeason}
              sizeFactor={sizeFactor}
            />
          </Col>
        </Row>
      </div>
    )
  }
}

export default TimelinePanel2;
